import { render } from "./benefit.vue?vue&type=template&id=2371f0e0"
import script from "./benefit.vue?vue&type=script&lang=js"
export * from "./benefit.vue?vue&type=script&lang=js"

import "./benefit.vue?vue&type=style&index=0&id=2371f0e0&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__